import { API } from "../../lib/api";

const ROLES = [["balloon", "Speech & thought balloons"], ["caption", "Captions"], ["sfx", "Sound effects"]];

export function FontPicker({ fonts, value, onChange }) {
  if (!fonts) return null;
  return (
    <div className="space-y-2" data-testid="comic-fonts">
      <p className="text-xs text-slate-400">Lettering fonts</p>
      {ROLES.map(([role, label]) => (
        <div key={role} className="space-y-1">
          <div className="flex items-center gap-2">
            <span className="text-[11px] text-slate-500 w-36 shrink-0">{label}</span>
            <select value={value[role]} onChange={(e) => onChange({ ...value, [role]: e.target.value })} className="flex-1 h-8 rounded-md bg-slate-900 border border-slate-700 px-2 text-xs" data-testid={`comic-font-${role}`}>
              {Object.entries(fonts).map(([k, n]) => <option key={k} value={k}>{n}</option>)}
            </select>
          </div>
          <img src={`${API}/comic-fonts/${value[role]}/preview`} alt={`${fonts[value[role]]} sample`} className="h-8 max-w-full sm:max-w-[calc(100%-9rem)] object-contain object-left rounded bg-white sm:ml-36" data-testid={`comic-font-preview-${role}`} />
        </div>
      ))}
    </div>
  );
}
